module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// C:/Users/Administrator/Desktop/sailing-work/mapbox/mapboxProject/node_modules/_axios@0.19.0@axios/index.js
// module id = Muz9
// module chunks = 1